<textarea
    [value]="model"
    (input)="modelChange.emit(input_el.value)"
    [attr.maxlength]="length"
    [placeholder]="placeholder"
    #input_el
></textarea>
<p class="count">{{model.length}}/{{length}}</p>
